import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    profStandards: [],
    isLoading: false,
    hasMore: false,
    error: null,
}

export const getAllProfessionalStandards = createAsyncThunk(
    'getAllProfessionalStandards',
    async ({page, limit}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getProfessionalStandards(page, limit);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const profStandardsSlice = createSlice({
    name: 'profStandardsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllProfessionalStandards.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllProfessionalStandards.fulfilled, (state, action) => {
                state.isLoading = false;
                state.profStandards = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllProfessionalStandards.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.profStandards = [];
                state.hasMore = false;
            })
    }
});

export const {} = profStandardsSlice.actions;

export default profStandardsSlice.reducer;
